<script setup lang="ts">
const props = defineProps<{
	gridTemplateAreas: string
	gridTemplateColumns: string
	gridTemplateRows: string
	gap: string
	areaNames: string[]
}>()
</script>
<template>
	<div
		:style="{
			display: 'grid',
			gridTemplateAreas: props.gridTemplateAreas,
			gridTemplateColumns: props.gridTemplateColumns ?? 'repeat(6, 1fr)',
			gridTemplateRows: props.gridTemplateRows ?? 'auto',
			gap: props.gap ?? '4px'
		}">
		<div v-for="area in props.areaNames" :key="area" :style="{ gridArea: area, alignSelf: 'start' }">
			<slot :name="area" />
		</div>
	</div>
</template>
